import * as api from "../routes/userroutefront";
import axios from "../config/axios";
import key from "../config/config";

export const generateAmoeCode = async (captchaToken) => {
  try {
    let respData = await axios({
      url: key.API_URL + api.amoeGenerate,
      method: "post",
      data: { captchaToken },
    });
    return {
      status: respData?.data?.status,
      message: respData?.data?.message,
      result: respData?.data?.result,
    };
  } catch (err) {
    return {
      status: err?.response?.data?.status,
      message: err?.response?.data?.message,
      kycStatus: err?.response?.data?.kycStatus,
    };
  }
};

export const getMyAmoeStatus = async () => {
  try {
    let respData = await axios({
      url: key.API_URL + api.amoeStatus,
      method: "get",
      params: { _: Date.now() },
      headers: { "Cache-Control": "no-cache" },
    });
    return { status: respData?.data?.status, result: respData?.data?.result };
  } catch (err) {
    return { status: false, result: null };
  }
};
